// extracted by mini-css-extract-plugin
module.exports = {"title":"Translate_title__2v-v8"};